<div class="visual-aid-container" [ngClass]="{ 'preloader': isLoading }">
  <ng-container *ngIf="isLoading; else content">
    <div class="loading-state">
      <qai-call-audio-indicator size="medium" status="loading" />
    </div>
  </ng-container>

  <ng-template #content>
    <img qai-image [objectFit]="'contain'" [src]="imgArray[currentPage]"
      alt="{{'call.VISUAL_AID_LOAD_ERROR' | transloco}}" [ngStyle]="{ 'width.%': 100 }" />
  </ng-template>

  <qai-page-navigator [currentPage]="currentPage + 1" [totalPages]="imgArray.length" (previousClicked)="previous()"
    (nextClicked)="next()" (closeVisualAidClicked)="onDisplayVisualAidButtonClick()"></qai-page-navigator>
</div>